import axiosClient from 'lib/axiosClient';
import { useSnackbar } from 'notistack';
import { useState } from 'react';

const useCodingProfileInsert = () => {
  const [loading, setLoading] = useState(false);
  const { enqueueSnackbar } = useSnackbar();

  const insertRequest = ({
    codeName,
    prefix,
    codeType,
    codeLogic,
    titleRequired,
    validationlength,
    validationlengthValue,
    decoder,
    skUlength,
    seriallength,
    formula,
    codePrefix,
    codePostfix,
    codeTrimStart,
    codeTrimEnd,
    onSuccess,
  }) => {
    setLoading(true);
    axiosClient
      .post(`SettingProduct/CoddingProfile/Insert`, {
        display: codeName,
        prefix,
        type: codeType,
        logic: codeLogic,
        titleRequired,
        validationlength,
        validationlengthValue,
        decoder,
        skUlength,
        seriallength,
        formula,
        codePrefix,
        codePostfix,
        codeTrimStart,
        codeTrimEnd,
      })
      .then(res => {
        if (res.status === 200) {
          enqueueSnackbar(`افزودن با موفقیت انجام شد`, { variant: 'success' });
          onSuccess?.();
        } else {
          enqueueSnackbar(res?.message, { variant: 'error' });
        }
      })
      .catch(err => {
        enqueueSnackbar(err?.message, { variant: 'error' });
      })
      .finally(() => setLoading(false));
  };
  return { insertRequest, loading };
};

export default useCodingProfileInsert;
